import { Observable } from 'rxjs/Observable';
import { delay, tap, shareReplay } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as JsSearch from 'js-search';
import { IoDiagnosis, NamedThing, IoDrug, IoDrugGroup } from '../../types';

import { ToastController } from 'ionic-angular';
import _ from 'lodash';
import { DrugDataStore } from './drug-data-store';
import { DataStore, IdentifyableObject } from './data-store';

const spacedStopWords = [
	" oder ",
	" und ",
	" der ",
	" die ",
	" das ",
	" des ",
	" in "
]

export const tokenizer = {
	tokenize(text: string): Array<string> {
		text = text.toLowerCase();
		text = text.replace(/ä/gu, 'a');
		text = text.replace(/ö/gu, 'o');
		text = text.replace(/ü/gu, 'u');
		text = text.replace(/ß/gu, 's');
		text = text.replace(/β/gu, 'b');
		text = text.replace(/⍺/gu, 'a');
		spacedStopWords.forEach((find) => { text = _.replace(text, find, "") });

		return text.match(/\b(\w+)\b/g) || [];
	}
};

@Injectable()
export class DataProvider {

	diagnosesIndex: JsSearch.Search;
	drugsIndex: JsSearch.Search;
	groupsIndex: JsSearch.Search;

	constructor(private http: HttpClient, private dds: DrugDataStore) {
	}

	loadAndInitializeData(dataUrl: string = "assets/data/compiled.json"): Observable<void> {
		return this.http.get<any>(dataUrl)
			.pipe(shareReplay(0), delay(50), tap(dataStoreData => {
				this.initializeData(dataStoreData);
			}));
	}

	private initializeData(dataStoreData: DrugDataStore) {
		this.diagnosesIndex = DataProvider.createIndex('id', 'name');
		this.drugsIndex = DataProvider.createIndex('id', 'name');
		this.drugsIndex.addIndex('registrationInfo');
		this.groupsIndex = DataProvider.createIndex('id', 'name');

		const dataStore = Object.assign(new DataStore(), dataStoreData.ds);

		this.dds.setDataStore(dataStore);

		this.diagnosesIndex.addDocuments((this.dds.getAllDiagnoses()));
		this.drugsIndex.addDocuments((this.dds.getAllDrugs()));
		this.groupsIndex.addDocuments((this.dds.getAllGroups()));
	}

	searchDiagnosis(term: string): Array<IoDiagnosis> {
		term = (term || '').trim();
		return (this.diagnosesIndex.search(term) as Array<IoDiagnosis>);
	}

	searchDrugs(term: string): Array<IoDrug> {
		term = (term || '').trim();
		return (this.drugsIndex.search(term) as Array<IoDrug>);
	}

	searchGroups(term: string): Array<IoDrugGroup> {
		term = (term || '').trim();
		return (this.groupsIndex.search(term) as Array<IoDrugGroup>);
	}

	public static createIndex(idProperty: string, indexPath: string | string[] = idProperty): JsSearch.Search {
		const search = new JsSearch.Search(idProperty);
		search.searchIndex = new JsSearch.UnorderedSearchIndex();
		search.tokenizer = tokenizer;
		search.addIndex(indexPath);
		return search;
	}
}

export function compareOrdered(a: (NamedThing & IdentifyableObject), b: (NamedThing & IdentifyableObject)) {
	return a.$sortOrder - b.$sortOrder;
}

export function sort(things: (NamedThing & IdentifyableObject)[]) {
	things.sort(compareOrdered);
}

export function getNormalizedNameForSorting(thing: NamedThing) {
	return thing.name.toLowerCase().replace(/β/gu, 'b');
}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts